export const iconColor = {
  idle: 'text-gray-500',
  pending: 'text-gray-500',
  success: 'text-green-500',
  failure: 'text-red-600'
}

export const statusText = {
  idle: 'Not loaded',
  pending: 'Loading',
  success: 'Loaded successfully',
  failure: 'Failed to load'
}
